import { createSlice } from "@reduxjs/toolkit";

import {
    getAllLeadSourcesAsync,
    getAllLeadSourcesTypesAsync,
    getBaseSource,
    getGoogleConnectedSources,
    getSchedules,
} from "./leadSources.asyncActions";

const initialState = {
    getAllLeadSourcesTypes: {
        message: "",
        status: "idle",
        leadSources: [],
    },
    getAllLeadSources: {
        message: "",
        status: "idle",
        leadSources: [],
    },
    getAllSchedules: {
        message: "",
        status: "idle",
        schedules: [],
    },
    sourceApiTypes: {
        message: "",
        status: "idle",
        data: [],
    },
    googleConnectedSourcesList: {
        data: [],
        isLoadingList: false,
    },
};

export const leadSourcesSlice = createSlice({
    name: "leadAllSourcesState",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllLeadSourcesTypesAsync.pending, (state) => {
                state.getAllLeadSourcesTypes.status = "loading";
            })
            .addCase(getAllLeadSourcesTypesAsync.fulfilled, (state, action) => {
                state.getAllLeadSourcesTypes.status = "success";
                state.getAllLeadSourcesTypes.leadSources =
                    action.payload.data && action.payload.data;
                state.getAllLeadSourcesTypes.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getAllLeadSourcesTypesAsync.rejected, (state, action) => {
                state.getAllLeadSourcesTypes.status = "failed";
                state.getAllLeadSourcesTypes.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getAllLeadSourcesAsync.pending, (state) => {
                state.getAllLeadSources.status = "loading";
            })
            .addCase(getAllLeadSourcesAsync.fulfilled, (state, action) => {
                state.getAllLeadSources.status = "success";
                state.getAllLeadSources.leadSources =
                    action.payload.data && action.payload.data;
                state.getAllLeadSources.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getAllLeadSourcesAsync.rejected, (state, action) => {
                state.getAllLeadSources.status = "failed";
                state.getAllLeadSources.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getSchedules.pending, (state) => {
                state.getAllSchedules.status = "loading";
            })
            .addCase(getSchedules.fulfilled, (state, action) => {
                state.getAllSchedules.status = "success";
                state.getAllSchedules.schedules =
                    action.payload.data && action.payload.data;
                state.getAllSchedules.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getSchedules.rejected, (state, action) => {
                state.getAllSchedules.status = "failed";
                state.getAllSchedules.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getBaseSource.pending, (state) => {
                state.sourceApiTypes.status = "loading";
            })
            .addCase(getBaseSource.fulfilled, (state, action) => {
                state.sourceApiTypes.status = "success";
                state.sourceApiTypes.data =
                    action.payload.data && action.payload.data;
                state.sourceApiTypes.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getBaseSource.rejected, (state, action) => {
                state.sourceApiTypes.status = "failed";
                state.sourceApiTypes.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getGoogleConnectedSources.pending, (state) => {
                state.googleConnectedSourcesList.isLoadingList = true;
            })
            .addCase(getGoogleConnectedSources.fulfilled, (state, action) => {
                state.googleConnectedSourcesList.isLoadingList = false;
                state.googleConnectedSourcesList.data = action.payload;
            })
            .addCase(getGoogleConnectedSources.rejected, (state, action) => {
                state.googleConnectedSourcesList.isLoadingList = false;
            });
    },
    googleConnectedSourcesList: {
        data: [],
        isLoadingList: false,
    },
});

export default leadSourcesSlice.reducer;
